/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <v-layout row wrap>
      <v-flex
        v-show="!loading"
        xs6
        sm6
        :class="dynamicCol"
        v-for="item in items"
        :key="item.key"
      >
        <Card class="br-4">
          <v-flex class="text-xs-center inner-card">
            <div class="ag-card-number font-weight-bold headline">
              <span
                :class="
                  item.value == 'N/A' || item.value == 'No Data'
                    ? 'error--text'
                    : 'number--text'
                "
                class="mr-1"
                >{{ item.value }}</span
              >
              <span
                v-if="item.value != 'No Data'"
                class="caption extraGrey--text unit"
                >{{ item.unit }}</span
              >
            </div>
            <div class="body-1 extraGrey--text">{{ $t(item.name) }}</div>
          </v-flex>
        </Card>
      </v-flex>
      <v-flex v-show="loading" xs6 sm6 class="md12">
        <Card class="br-4">
          <v-flex class="text-xs-center inner-card">
            <div class="ag-card-number font-weight-bold headline">
              {{ $t("Loading") }} ...
            </div>
          </v-flex>
        </Card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Inverter from "@/services/Inverter";
import { mixin, mapGettersMixin, miscellaneous } from "@/util/mixin/index";
const momentTz = require('moment-timezone')

export default {
  mixins: [mixin, mapGettersMixin, miscellaneous],
  props: {
    date: {
      type: Object
    },
  },
  data() {
    return {
      selectedPlant: "",
      start_date: "",
      end_date: "",
      items: [],
      loading: true,
      enableWatch: false,
    };
  },
  async mounted() {
    if (!(this.date && this.date.from)) {
      this.start_date = momentTz().tz(this.getActivePlantInfo("timezone")).format("YYYY-MM-DD")
    } else {
      this.start_date = this.date.from
    }

    if (!(this.date && this.date.to)) {
      this.end_date = momentTz().tz(this.getActivePlantInfo("timezone")).format("YYYY-MM-DD")
    } else {
      this.end_date = this.date.to
    }
    this.selectedPlant = this.getSelectedPlantId;
    await this.setIntervalWithoutDelay(this.getGenerationData);
  },
  computed: {
    ...mapGetters(["getUserInfo", "getSelectedPlantId", "getActivePlantInfo"]),
    dynamicCol() {
      if (this.items.length === 1) {
        return {
          md12: true,
        };
      } else if (this.items.length === 2) {
        return {
          md6: true,
        };
      } else if (this.items.length === 3) {
        return {
          md4: true,
        };
      } else if (this.items.length === 4) {
        return {
          md3: true,
        };
      } else if (this.items.length === 5) {
        return {
          md2: true,
          "card-5": true,
        };
      } else if (this.items.length === 6) {
        return {
          md2: true,
        };
      } else {
        return {
          md2: true,
        };
      }
    },
  },
  methods: {
    async getGenerationData() {
      this.loading = true;
      this.enableWatch = true;
      try {
        const param = this.getHeaderParam();
        let response = await Inverter.fetchHeader(param);
        this.items = response.data.message;
        this.loading = false;
      } catch (err) {
        this.items = [];
        this.loading = false;
      }
    },
    getHeaderParam() {
      return {
        plantId: this.selectedPlant,
        dateFrom: this.start_date,
        dateTo: this.end_date,
      };
    },
  },
  watch: {
    getSelectedPlantId(val) {
      this.selectedPlant = val;
      this.getGenerationData();
    },
    date(val, oldVal) {
      if (this.enableWatch && !this.isObjectEqual(oldVal, val)) {
        this.start_date = this.date.from;
        this.end_date = this.date.to;
        this.getGenerationData();
      }
    },
  },
};
</script>

<style scoped>
.unit {
  margin-top: -8px;
}

.inner-card {
  width: 100%;
  padding: 8px;
  height: 68px;
  /* display: grid; */
}

.single-card {
  padding: 4px;
}

.card-5 {
  min-width: 20%;
}

@media only screen and (min-width: 320px) and (max-width: 600px) {
  .ag-card-number {
    font-size: 20px !important;
  }
}
</style>
